import { WEBSITE_URL } from '../../../../shared/config/constants';
import { MEASUREMENT_ID } from '../../config/constants';

export const BAZEFIELD_FETCH_DATA_NEW = 'BAZEFIELD_FETCH_DATA_NEW';
export const BAZEFIELD_FETCH_DATA_LOADING = 'BAZEFIELD_FETCH_DATA_LOADING';
export const BAZEFIELD_FETCH_DATA_LOADED = 'BAZEFIELD_FETCH_DATA_LOADED';
export const BAZEFIELD_FETCH_DATA_ERROR = 'BAZEFIELD_FETCH_DATA_ERROR';

export function fetchData(status = BAZEFIELD_FETCH_DATA_NEW) {
  return (dispatch) => {
    if (status !== BAZEFIELD_FETCH_DATA_LOADING) {
      dispatch({
        type: BAZEFIELD_FETCH_DATA_LOADING,
      });

      fetch(`${WEBSITE_URL}/data/turbine/${MEASUREMENT_ID}`, {
        mode: 'cors',
      })
        .then((data) => data.json())
        .then((data) => {
          dispatch({
            type: BAZEFIELD_FETCH_DATA_LOADED,
            ...data,
          });
        })
        .catch((error) => {
          dispatch({
            type: BAZEFIELD_FETCH_DATA_ERROR,
            error: error,
          });
        });
    }
  };
}
